import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';

/**
 * Sets a native title tooltip only when text is truncated (ellipsis).
 * Uses the same overflow detection as CSS truncation: scrollWidth > clientWidth.
 */
@Directive({
  selector: '[cygovTooltipIfTruncated]',
  standalone: true,
})
export class TooltipIfTruncatedDirective implements AfterViewInit, OnDestroy {
  @Input() cygovTooltipIfTruncated: string = '';

  // Title is set at render (QA checks it statically), then re-checked on size/content changes.
  private observer: ResizeObserver;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.update();
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.el.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  @HostListener('mouseenter')
  @HostListener('window:resize')
  update(): void {
    const element = this.el.nativeElement;
    const text = this.cygovTooltipIfTruncated || element.textContent?.trim() || '';
    // not laid out yet (e.g. a tab still opening): keep the title; height catches line clamps
    const unmeasured = !element.getClientRects().length;
    const truncated = element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
    if (text && (unmeasured || truncated)) {
      element.setAttribute('title', text);
    } else {
      element.removeAttribute('title');
    }
  }
}
